module.exports = __webpack_public_path__ + "static/logo-white-e9b20293660008c9b17871ccf8527991.png";